import { type NumberInputProps } from '@mantine/core';
import { NumberInput } from '../../inputs/NumberInput';
import { useEditorContext } from '../EditorContext';
import { ModalEditorItemBase } from './ModalEditorItemBase';

export interface ModalNumberItemProps<TFormType> extends NumberInputProps {
    label?: string;
    labelWidth?: number;
    fieldKey: keyof TFormType;
    required?: boolean;
}

export const ModalNumberItem = <TFormType,>({
    label,
    labelWidth,
    fieldKey,
    required,
    ...numberInputProps
}: ModalNumberItemProps<TFormType>) => {
    const { form, loading, onSave } = useEditorContext<TFormType>();

    const fieldKeyString = fieldKey as string;
    const error = form.errors[fieldKeyString];

    return (
        <ModalEditorItemBase
            label={label}
            labelWidth={labelWidth}
            error={error}
            required={required}
            submitChanges={onSave}
        >
            <NumberInput
                key={form.key(fieldKeyString)}
                {...form.getInputProps(fieldKeyString)}
                readOnly={loading}
                required={required}
                error={false}
                {...numberInputProps}
            />
        </ModalEditorItemBase>
    );
};
